import React, { useRef, useState } from 'react';
import { Button, Modal, Space, message, Card } from 'antd';
import { ReloadOutlined, FolderOpenOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import FormSetting from './FormSetting';
import { FormDialog, handleException, useHeighter } from './Utils';
import { hasRight } from './Login';



function ModuleSetting({visible=true}) {	
	const formRef = useRef(null);	
	const writeRight = hasRight('settings');
	const [height] = useHeighter(180);

	return (
		<div style={{ display: visible?'block':'none' }}>
			<h1>Nastavení</h1>	
			<div style={{height:height, overflowY:'auto'}}>			
			<Space direction="vertical" size="large" style={{width:'100%'}}>			
				<Card title="Credit" style={{ width:'auto', display: 'inline-block' }}>
					<FormSetting style={{backgroundColor:'transparent',width:700}} recid={'credits'} ref={formRef} writeRight={writeRight}/>
				</Card>
				<Card title="Hodiny přiřazení" style={{ width:'auto', display: 'inline-block' }}>
					<FormSetting style={{backgroundColor:'transparent',width:700}} recid={'assign_hours'} ref={formRef} writeRight={writeRight}/>
				</Card>
				<Card title="E-mail" style={{ width:'auto', display: 'inline-block' }}>
					<FormSetting style={{backgroundColor:'transparent',width:700}} recid={'mails'} ref={formRef} writeRight={writeRight}/>
				</Card>
			</Space>
			</div>
		</div>
	);
};

export default ModuleSetting;

